<template>
    <div class="skeleton-container">
        <div class="skeleton">
            <div v-for="index in maxNumberOfProducts" :key="index" class="skeleton-div">
                <SkeletonPartsImage aspect="1:1" />
                <div class="mt-3">
                    <SkeletonPartsText />
                    <SkeletonPartsText />
                    <SkeletonPartsText />
                </div>
                <div class="mt-3">
                    <SkeletonPartsText />
                </div>
                <div class="mt-3">
                    <SkeletonPartsText />
                </div>
                <div class="mt-3 d-flex justify-content-center">
                    <SkeletonPartsButton />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const maxNumberOfProducts = 6
</script>

<style lang="scss" scoped>
.skeleton-container {
    position: relative;

    @media (min-width: 992px) {
        margin-right: calc(-0.5 * var(--bs-gutter-x));
        margin-left: calc(-0.5 * var(--bs-gutter-x));
    }
}
.skeleton {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.skeleton-div {
    flex: 0 0 calc(100% / 2);
    width: calc(100% / 2);
    padding: 1.5em 0.5em 0.5em;

    @media (min-width: 992px) {
        flex: 0 0 calc(100% / 3);
        width: calc(100% / 3);
    }
}
</style>
